export function calculateTotalDuration(
  duration: number,
  advanceDelay: number,
  frameCount: number,
) {
  const safeDuration = Math.max(0, duration);
  const pause = Math.max(0, advanceDelay);
  const transitions = Math.max(0, frameCount - 1);
  return safeDuration + pause * transitions;
}
